import { render, staticRenderFns } from "./requester-type-master.vue?vue&type=template&id=62a284d6&"
import script from "./requester-type-master.vue?vue&type=script&lang=js&"
export * from "./requester-type-master.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports